// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\TopicCards\TopicCardsResponse.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Berth, BerthData, BerthOptions } from 'data/models/Berth';
import { PortCall, PortCallData, PortCallOptions } from 'data/models/PortCall';
import { TopicCard, TopicCardData, TopicCardOptions } from 'data/models/TopicCard';
import { ApplicableTopicCardTemplate as _ApplicableTopicCardTemplate, ApplicableTopicCardTemplateData as _ApplicableTopicCardTemplateData, ApplicableTopicCardTemplateOptions as _ApplicableTopicCardTemplateOptions, TopicCardViewModel as _TopicCardViewModel, TopicCardViewModelData as _TopicCardViewModelData, TopicCardViewModelOptions as _TopicCardViewModelOptions } from 'data/models/TopicCardsResponse';
import { TopicCardTemplate, TopicCardTemplateData, TopicCardTemplateOptions } from 'data/models/TopicCardTemplate';

// TopicCardsResponseData is the class that TopicCardsResponse serializes to/from
export interface TopicCardsResponseData {
    Id : number;
	
    ApplicableTemplates : _ApplicableTopicCardTemplateData[] | null;
    GetOrgId : number[];
    PortCall : PortCallData | null;
    TopicCards : _TopicCardViewModelData[] | null;
	
    CanEditPortCall : boolean;
    CanManageServices : boolean;
}

// TopicCardsResponseOptions is the class which may be passed to the TopicCardsResponse constructor to define optional initial data values
export interface TopicCardsResponseOptions {
    Id : number;
	
    ApplicableTemplates? : _ApplicableTopicCardTemplateOptions[] | null;
    GetOrgId? : number[];
    PortCall? : PortCallOptions | null;
    TopicCards? : _TopicCardViewModelOptions[] | null;
	
    CanEditPortCall? : boolean;
    CanManageServices? : boolean;
}

export class TopicCardsResponse {
    public Id : DataSignal<number>;
	
    public ApplicableTemplates : SDataArray<_ApplicableTopicCardTemplate>;
    public GetOrgId : SDataArray<number>;
    public PortCall : DataSignal<PortCall | null>;
    public TopicCards : SDataArray<_TopicCardViewModel>;
	
    public CanEditPortCall : DataSignal<boolean>;
    public CanManageServices : DataSignal<boolean>;

    constructor();
    constructor(data : TopicCardsResponseOptions);
    constructor(data: TopicCardsResponseOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.ApplicableTemplates = SArray<_ApplicableTopicCardTemplate>([]);
        this.GetOrgId = jsonableObservable(SArray<number>(data && data.GetOrgId !== undefined ? data.GetOrgId : []));
        this.PortCall = S.value<PortCall | null>(null);
        this.TopicCards = SArray<_TopicCardViewModel>([]);
	    
        this.CanEditPortCall = jsonableObservable(S.value<boolean>(data && data.CanEditPortCall !== undefined ? data.CanEditPortCall : false));
        this.CanManageServices = jsonableObservable(S.value<boolean>(data && data.CanManageServices !== undefined ? data.CanManageServices : false));
    }

    static key(obj : TopicCardsResponse) {
        return obj.Id();
    }
    
    static dataKey(obj : TopicCardsResponseOptions) {
        return obj.Id;
    }

    static update(obj : TopicCardsResponse, data : TopicCardsResponseOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.GetOrgId !== undefined) obj.GetOrgId(data.GetOrgId);
	        
            if (data.CanEditPortCall !== undefined) obj.CanEditPortCall(data.CanEditPortCall);
            if (data.CanManageServices !== undefined) obj.CanManageServices(data.CanManageServices);
        });
    }
}

// TopicCardViewModelData is the class that TopicCardViewModel serializes to/from
export interface TopicCardViewModelData {
    Id : number;
	
    Card : TopicCardData | null;
    PortCallId : number;
	
    CanConfirm : boolean;
    CanEdit : boolean;
}

// TopicCardViewModelOptions is the class which may be passed to the TopicCardViewModel constructor to define optional initial data values
export interface TopicCardViewModelOptions {
    Id : number;
	
    Card? : TopicCardOptions | null;
    PortCallId? : number;
	
    CanConfirm? : boolean;
    CanEdit? : boolean;
}

export class TopicCardViewModel {
    public Id : DataSignal<number>;
	
    public Card : DataSignal<TopicCard | null>;
    public PortCallId : DataSignal<number>;
	
    public CanConfirm : DataSignal<boolean>;
    public CanEdit : DataSignal<boolean>;

    constructor();
    constructor(data : TopicCardViewModelOptions);
    constructor(data: TopicCardViewModelOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Card = S.value<TopicCard | null>(null);
        this.PortCallId = jsonableObservable(S.value<number>(data && data.PortCallId !== undefined ? data.PortCallId : 0));
	    
        this.CanConfirm = jsonableObservable(S.value<boolean>(data && data.CanConfirm !== undefined ? data.CanConfirm : false));
        this.CanEdit = jsonableObservable(S.value<boolean>(data && data.CanEdit !== undefined ? data.CanEdit : false));
    }

    static key(obj : TopicCardViewModel) {
        return obj.Id();
    }
    
    static dataKey(obj : TopicCardViewModelOptions) {
        return obj.Id;
    }

    static update(obj : TopicCardViewModel, data : TopicCardViewModelOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.PortCallId !== undefined) obj.PortCallId(data.PortCallId);
	        
            if (data.CanConfirm !== undefined) obj.CanConfirm(data.CanConfirm);
            if (data.CanEdit !== undefined) obj.CanEdit(data.CanEdit);
        });
    }
}

// ApplicableTopicCardTemplateData is the class that ApplicableTopicCardTemplate serializes to/from
export interface ApplicableTopicCardTemplateData {
    BerthId : number | null;
    PortCallId : number;
    TemplateId : number;
	
    Berth : BerthData | null;
    Template : TopicCardTemplateData | null;
	
    CanAnswer : boolean;
}

// ApplicableTopicCardTemplateOptions is the class which may be passed to the ApplicableTopicCardTemplate constructor to define optional initial data values
export interface ApplicableTopicCardTemplateOptions {
    BerthId : number | null;
    PortCallId : number;
    TemplateId : number;
	
    Berth? : BerthOptions | null;
    Template? : TopicCardTemplateOptions | null;
	
    CanAnswer? : boolean;
}

export class ApplicableTopicCardTemplate {
    public BerthId : DataSignal<number | null>;
    public PortCallId : DataSignal<number>;
    public TemplateId : DataSignal<number>;
	
    public Berth : DataSignal<Berth | null>;
    public Template : DataSignal<TopicCardTemplate | null>;
	
    public CanAnswer : DataSignal<boolean>;

    constructor();
    constructor(data : ApplicableTopicCardTemplateOptions);
    constructor(data: ApplicableTopicCardTemplateOptions | null = null) {
        this.BerthId = jsonableObservable(S.value<number | null>(data && data.BerthId !== undefined ? data.BerthId : null));
        this.PortCallId = jsonableObservable(S.value<number>(data && data.PortCallId !== undefined ? data.PortCallId : 0));
        this.TemplateId = jsonableObservable(S.value<number>(data && data.TemplateId !== undefined ? data.TemplateId : 0));
	    
        this.Berth = S.value<Berth | null>(null);
        this.Template = S.value<TopicCardTemplate | null>(null);
	    
        this.CanAnswer = jsonableObservable(S.value<boolean>(data && data.CanAnswer !== undefined ? data.CanAnswer : false));
    }

    static key(obj : ApplicableTopicCardTemplate) {
        return (obj.BerthId() === null ? NaN : obj.BerthId()!) + '\u2618' + obj.PortCallId() + '\u2618' + obj.TemplateId();
    }
    
    static dataKey(obj : ApplicableTopicCardTemplateOptions) {
        return (obj.BerthId === null ? NaN : obj.BerthId) + '\u2618' + obj.PortCallId + '\u2618' + obj.TemplateId;
    }

    static update(obj : ApplicableTopicCardTemplate, data : ApplicableTopicCardTemplateOptions) {
        S.freeze(() => {
            if (data.BerthId !== undefined) obj.BerthId(data.BerthId);
            if (data.PortCallId !== undefined) obj.PortCallId(data.PortCallId);
            if (data.TemplateId !== undefined) obj.TemplateId(data.TemplateId);
	        
	        
            if (data.CanAnswer !== undefined) obj.CanAnswer(data.CanAnswer);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/TopicCardsResponse.ts